import React, { useEffect, useState } from 'react';
import { useQuery, useSubscription } from 'urql';
import { GraphqlOperations } from '../../../../logic/graphql/operations';
import { Query, Subscription } from '../../../../logic/graphql/types/types';
import styled from 'styled-components';

const BadgeContainer = styled.span`
  position: absolute;
  top: 0px;
  right: 0px;
  height: 18px;
  min-width: 18px;
  background: #eb5757;
  font-weight: bold;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
  letter-spacing: -0.01em;
  border-radius: 9px;
  box-shadow: 0px 0px 10px #eb5757;
  padding: 0px 3px;
`;

const NotificationBadge = (): JSX.Element | null => {
  const [notificationCount, setNotficicationCount] = useState<number | undefined>(undefined);
  const notificationQueryResult = useQuery<Query>({
    query: GraphqlOperations.queries.get_unread_notifications_count.queryString,
  })[0];

  const handleSubscription = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _notificationCounts: number[] = [],
    response: Subscription,
  ): number[] => {
    if (response && response.notification_unread_count !== undefined) {
      setNotficicationCount(response.notification_unread_count);
    }
    return [];
  };

  useSubscription(
    {
      query: GraphqlOperations.subscriptions.notification_unread_count.subscriptionString,
    },
    handleSubscription,
  );

  const notificationCountData = notificationQueryResult.data?.get_unread_notifications_count;

  useEffect(() => {
    if (notificationCount === undefined && notificationCountData !== undefined) {
      setNotficicationCount(notificationCountData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationCountData]);

  const indicatedNotificationsCount = notificationCount
    ? notificationCount < 100
      ? notificationCount
      : '99+'
    : undefined;

  if (indicatedNotificationsCount) {
    return <BadgeContainer>{indicatedNotificationsCount}</BadgeContainer>;
  }
  return null;
};

export default NotificationBadge;
